<mat-dialog-content class="text">
  Welcome to FitForce Planner! Click the button to begin a guided tour.
</mat-dialog-content>
<mat-dialog-actions style="justify-content:space-evenly">
  <button mat-raised-button [mat-dialog-close]="true" (click)="startTour()" color="primary">Start Tour</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">Close</button>
</mat-dialog-actions>